import * as React from "react";

function SvgWindsorIo(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 281.5 285"
      {...{ ...props, ref }}
    >
      <g clipPath="url(#WindsorIO_svg__clip0)">
        <mask
          id="WindsorIO_svg__a"
          style={{
            maskType: "alpha",
          }}
          width={283}
          height={283}
          x={-1}
          y={0}
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#111"
            fillRule="evenodd"
            d="M66.493 8.882C90.133 2.961 114.957 0 140.966 0s50.833 2.96 74.473 8.882a79.333 79.333 0 0157.679 57.679C279.039 90.2 282 115.025 282 141.034s-2.961 50.833-8.882 74.473a79.335 79.335 0 01-57.679 57.679c-23.64 5.921-48.464 8.882-74.473 8.882s-50.833-2.961-74.473-8.882a79.333 79.333 0 01-57.679-57.679c-5.921-23.64-8.882-48.464-8.882-74.473s2.96-50.833 8.882-74.473A79.332 79.332 0 0166.493 8.882z"
            clipRule="evenodd"
          />
        </mask>
        <g mask="url(#WindsorIO_svg__a)">
          <path
            fill="url(#WindsorIO_svg__paint0_linear)"
            d="M.412.273h281.176V281.45H.412z"
          />
          <path
            fill="#fff"
            d="M160.633 190.361h-26.152l-15.533-49.135h-.317l-15.216 49.135H77.262L50 111.428h28.055l13.63 49.928h.476l14.107-49.928h26.152l14.582 49.928h.317l13.79-49.928h26.945l-27.421 78.933zm63.954-104.134c0 2.007-.423 3.91-1.268 5.706a13.175 13.175 0 01-3.17 4.438c-1.268 1.268-2.853 2.272-4.755 3.011a14.843 14.843 0 01-5.706 1.11c-4.227 0-7.767-1.374-10.62-4.121-2.853-2.853-4.279-6.234-4.279-10.144 0-1.902.37-3.699 1.109-5.39.74-1.796 1.797-3.328 3.17-4.596a15.836 15.836 0 014.755-3.011c1.797-.846 3.751-1.268 5.865-1.268 2.007 0 3.909.37 5.706 1.11 1.902.739 3.487 1.743 4.755 3.01 1.373 1.269 2.43 2.801 3.17 4.597.845 1.691 1.268 3.54 1.268 5.548zM196.691 190.36v-78.933h25.994v78.933h-25.994z"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="WindsorIO_svg__paint0_linear"
          x1={78.294}
          x2={-166.528}
          y1={-142.947}
          y2={190.932}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E64CFF" />
          <stop offset={1} stopColor="#FF860B" />
        </linearGradient>
        <clipPath id="WindsorIO_svg__clip0">
          <path fill="#fff" d="M0 0h282v282H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.forwardRef(SvgWindsorIo);
